import {GameColor} from '../../../../shared/scripts/GameColor'
import {ItemCountView} from '../../../../shared/scripts/ui_canvas_engine/ItemCountView'
import {UIGamePlayerInformationLongestRoadView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationLongestRoadView'
import {UIPlayerAdditionalInformationLayer} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'

export class UIMGamePlayerInformationLongestRoadView extends UIGamePlayerInformationLongestRoadView {
    protected createMyDefaultLongestRoadView() {
        this.createLongestRoadView()
    }

    protected createMyCitiesAndKnightsLongestRoadView() {
        this.createLongestRoadView()
    }

    protected createOpponentDefaultLongestRoadView() {
        this.createLongestRoadView()
    }

    protected createOpponentCitiesAndKnightsLongestRoadView() {
        this.createLongestRoadView()
    }

    private createLongestRoadView() {
        const container = this.playerInformation.getContainerForAdditionalPlayerInformation(UIPlayerAdditionalInformationLayer.Layer0)
        const w = container.width
        const h = container.height

        const iconX = w * 0.05 + w * 0.5
        const iconY = h * 0.5
        const iconW = h * 0.5
        const iconH = iconW

        const countX = iconX + iconW * 0.5
        const countY = iconY
        const countH = iconH
        const countW = countH * 2

        const iconPadding = 0
        const fontSize = iconH * 0.75
        this.longestRoadView = new ItemCountView(iconX, iconY, iconW, iconH, container, this.longestRoadTexture,
            countX, countY, countW, countH, iconPadding, 12, GameColor.getColor(GameColor.Color.White))
        this.longestRoadView.count.changeStyle({fontSize: fontSize})
    }
}

